import { StoreState } from '../store';
import { EditorType } from '@wix/business-manager-api';

export const getUISetting = ({ pendingState }: StoreState) => pendingState;

export const isAppEnabled = (store: StoreState) => getUISetting(store)!.appSettings.appEnabled;
export const getTranslations = (store: StoreState) => getUISetting(store)!.appSettings.texts;
export const getAppSettings = (store: StoreState) => getUISetting(store)!.appSettings;
export const getSiteLanguage = (store: StoreState) => store.siteLanguage;
export const getLiveSiteUrl = (store: StoreState) => store.liveSite!.viewUrl;
export const getIsSitePublished = (store: StoreState) => store.liveSite!.isSitePublished;
export const isADISite = (store: StoreState) => store.liveSite!.editorType === EditorType.ADI;
export const isEditorX = (store: StoreState) => store.liveSite!.editorType === EditorType.EDITORX;
export const getKBLinks = ({ kbs }: StoreState) => kbs;
export const isDeclineAllEnabled = (store: StoreState) => getUISetting(store)!.appSettings.declineAllConfig.enabled;
